import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NumberInputComponent } from './number-input.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { LngLatPickerModule } from '@components/lng-lat-picker/lng-lat-picker.module'

@NgModule({
  declarations: [NumberInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    ContentEditableModule,
    LngLatPickerModule,
  ],
  exports: [NumberInputComponent],
})
export class NumberInputModule {}
